import { ImsObject } from './ims_object';
import { RadioTechnologyResource } from 'app/shared/resources';

export const IMS_TYPE__RADIO_TECHNOLOGY_TYPE = 'radio_technology_type';

class RadioTechnologyType extends ImsObject {
    constructor(resource = new RadioTechnologyResource()) {
        super(IMS_TYPE__RADIO_TECHNOLOGY_TYPE, resource);
    }

    get name() {
        return this.resource.type.toUpperCase();
    }

    set name(name) {
        this.resource.type = name;
    }

    static toFilterable(radioTechnologyType: RadioTechnologyType): any {
        // This is a hack to get around the fact that RadioTechnologyType are stored in lowercase in the database
        // And also that RadioTechnologyType is NOT a proper ImsObject (it doesn't have an id)
        return {
            value: radioTechnologyType.resource.type, // Used as the filter value, follow what's in the database
            label: radioTechnologyType.name,
        };
    }
}
